import * as ACTION from './constants';

// ACTION CREATORS
export const formBase = () => ({ type: ACTION.FORM_BASE });
export const isSubmitted = () => ({ type: ACTION.FORM_SUBMITTED });
export const setForm = (form = null, initial = false) => ({ type: ACTION.FORM_SET, form, initial });
export const updateSetsVideo = (item = null) => ({ type: ACTION.UPDATE_SETS_VIDEO, item });
